<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" v-if="showModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('create') }} {{ $t('group') }}</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="createGroup">
                            <div class="form-group">
                                <label for="name" class="form-label">{{ $t('name') }} *</label>
                                <input type="text" class="form-control" id="name" v-model="group.name" required>
                            </div>
                            <div class="form-group">
                                <label for="address" class="form-label">{{ $t('address') }} *</label>
                                <input type="text" class="form-control" id="address" v-model="group.address" required>
                            </div>
                            <div class="form-group">
                                <label for="zip" class="form-label">{{ $t('postalCode') }} *</label>
                                <input type="text" class="form-control" id="zip" v-model="group.postalCode" required>
                            </div>
                            <div class="form-group">
                                <label for="city" class="form-label">{{ $t('city') }} *</label>
                                <input type="text" class="form-control" id="city" v-model="group.city" required>
                            </div>
                            <div v-if="message" :class="alertClass">
                                {{ message }}
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-primary">{{ $t('apply') }}</button>
                                <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('cancel')
                                    }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import axios from 'axios';

export default {
    data() {
        return {
            group: {
                name: '',
                address: '',
                postalCode: '',
                city: ''
            },
            message: '',
            alertClass: ''
        };
    },
    emits: ['close-modal', 'data-updated'],
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async createGroup() {
            this.message = ''; // Clear previous message
            console.log('Creating group:', this.group);
            const fullAddress = `${this.group.address}, ${this.group.postalCode} ${this.group.city}`;
            const groupData = {
                name: this.group.name,
                address: fullAddress
            };
            try {
                const token = getCookie('token');
                const response = await axios.post(`${this.$url}/groups`,
                    {
                        ...groupData,
                        action: 'create'
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + token,
                            ContentType: 'application/json'
                        }
                    });
                console.log('Group created:', response.data);
                // Handle successful response
                this.setMessage(this.$t('group_created'), true);
                this.$emit('data-updated');
                // Close modal after 3 seconds
                setTimeout(() => {
                    this.closeModal();
                    this.message = ''; // Clear confirmation message
                }, 3000);
            } catch (error) {
                console.error('Error creating group:', error);
                if (error.response && error.response.data) {
                    this.setMessage(this.$t('error') + ': ' + error.response.data, false);
                } else {
                    this.setMessage(this.$t('error') + ': ' + error.message, false);
                }
            }
        },
        closeModal() {
            this.$emit('close-modal');
        },
        setMessage(message, isSuccess) {
            this.message = message;
            this.alertClass = isSuccess ? 'alert alert-success' : 'alert alert-warning';
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed */
}
</style>